import { render, staticRenderFns } from "./orderPlus.vue?vue&type=template&id=4a625096"
import script from "./orderPlus.vue?vue&type=script&lang=js"
export * from "./orderPlus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports